import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 820,
	height: 365,
	fill: "none",
	viewBox: "0 0 820 365",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#F5D493",
			d: "M16.4 229.4a38.8 38.8 0 0 0 18 69.5c149.8 21.8 443.3 62.4 548.6 62.4 148-30.5 150-45 198-61 0-31.5-438.6-196-582.5-196-35.2 15.3-120 77.7-182.1 125Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#993F00",
			d: "m786.4 308.2 14.3 1.9a3 3 0 0 0 3.4-3v-43a3 3 0 0 0-3.6-2.9l-14.3 3a3 3 0 0 0-2.4 2.9v38.1a3 3 0 0 0 2.6 3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#BC4D00",
			d: "M630.6 336.3v33.3a3 3 0 0 1-3 3h-14.3a3 3 0 0 1-3-3v-72.5a3 3 0 0 1 2-2.8l202.8-79a3 3 0 0 1 4.1 2.9v84a3 3 0 0 1-1.9 2.7l-11.3 4.7a3 3 0 0 1-4.1-2.8v-38.5a3 3 0 0 0-4.2-2.7l-165.2 67.9a3 3 0 0 0-1.9 2.8Zm-42.3-.4-448.6-81a3 3 0 0 1-2.5-3v-36.8a3 3 0 0 1 3.5-3l448.7 75.4a3 3 0 0 1 2.5 3v42.4a3 3 0 0 1-3.6 3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#993F00",
			d: "m142.6 306-10.1 3.2a3 3 0 0 1-4-2.8v-87.5a3 3 0 0 1 2.5-3l10.2-1.8a3 3 0 0 1 3.5 3v86a3 3 0 0 1-2 2.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D66313",
			d: "m373.2 151.6-241.2 66a3 3 0 0 1-3.8-2.9V45.1a3 3 0 0 1 2.5-3L369.4 5.8a3 3 0 0 1 3.5 3l2.5 139.8a3 3 0 0 1-2.2 3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F6751B",
			d: "m127.2 45-16.7-4.7L354.5.8a31 31 0 0 1 9.6 0l6.6 1a3 3 0 0 1 2.5 3v.9a3 3 0 0 1-2.6 3L128.4 45a3 3 0 0 1-1.2-.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#BC4D00",
			d: "M110 42.3v263.4a3 3 0 0 0 2.7 3l14.2 2a3 3 0 0 0 3.5-3L128.5 43c0-.7-.2-1.4-.8-1.8-1.2-.6-3.8-1.6-9-1.6-5.8 0-7.7 1.2-8.3 1.9-.3.2-.3.5-.3.9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#993F00",
			d: "M591.5 291.6v72.8a3 3 0 0 0 2 2.9l13.2 4.4c2 .6 4-.8 4-2.9v-72a3 3 0 0 0-2-2.8l-13.1-5.2a3 3 0 0 0-4.1 2.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFF4E0",
			d: "m140.5 207 4.3 5.5a3 3 0 0 0 1.8 1.1l464 81a3 3 0 0 0 1.6-.2l200.2-77.6a3 3 0 0 0 2-2.8v-54.4a3 3 0 0 0-2.7-3L376 95.6a3 3 0 0 0-1.2.2L142 158.6a3 3 0 0 0-2.2 3v43.6c0 .7.3 1.3.7 1.9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFE7BA",
			d: "m140.1 206.7 5 6.3c.2.3.6.4 1 .5l463.6 80.9c.9.2 1.7-.5 1.7-1.5V247c0-.7-.5-1.3-1.2-1.4l-292.7-51.4-176-31.7c-.8-.1-1.7.6-1.7 1.5v41.7c0 .4.1.7.3 1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFF4E0",
			d: "M251.2 80.2c-32.4 5.4-63.7-2.6-80.1 26-1.5 2.5-3.1 3.8-3.4 6.7a17 17 0 0 0 1.5 6.8c.6 1.2 11 21.3 39.5 39.5 13 8.3 55.3 14 71.5 14H295c5.6 0 8.8-.6 14.3-1.6 33.7-5.7 70.6-46 79.6-56.3a3 3 0 0 0-.5-4.3l-41.6-30.4c-.4-.3-.9-.5-1.4-.5-7-.7-60-5.6-94 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#993F00",
			fillOpacity: .6,
			d: "m168.4 156.6-1.4-41.3a3 3 0 0 1 3.7-3c7.7 1.8 25.2 6.1 35.7 9.6 16.1 5.5 25.5 8 40.3 16.2a233.3 233.3 0 0 1 33 24.8c2.6 2.2 5.7 3.6 9 3.9l12 1c4 .3 8-1 11-3.5l8-6.7a3 3 0 0 1 2.7-.6l77.4 19.8a3 3 0 0 1 2 4L400 186a3 3 0 0 1-3.4 2l-75.7-15.4-3-.3c-5.3 0-22.5.2-34.3 1.1-40.7 3-101-11.1-113-14.1a3 3 0 0 1-2.2-2.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#647693",
			d: "M373.6 84.2c-14 9.3-16 35.3-16.2 39.6 0 .4 0 .8.2 1.2l8.7 28.7a4 4 0 0 1-.3 3l-7.4 12.6a3.8 3.8 0 0 0 3.4 5.6l22.3-1c2 0 3.6-1.7 3.6-3.8v-12c0-1.7 1-3.1 2.7-3.6l52.2-15.5c.5-.2 1-.4 1.4-.8l31-26.1a3.8 3.8 0 0 0-.9-6.3l-50.6-23.2a31.2 31.2 0 0 0-8-2.6c-9.1-1.3-30.7-3.5-42.1 4.2Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 317.9,
			cy: 102.1,
			fill: "#FFCAAE",
			rx: 28.8,
			ry: 36.6,
			transform: "rotate(-61 318 102.1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M316.8 91.4c3.8-8.4-6-14.5-6-14.5s6.2-4.4 16.7 0c4.7 2 3.8-2.3 3.8-2.3s-10-14-23.3-12.1c-8.4 1.2-7 5-14.1 9.6-6.4 4-10.2 2.1-16 9.9-4.3 5.6-13.3 14.5-9.1 20.5 1.7 2.5 3.4 1.3 4.8 4 2 4.3-1.3 8.3 4.2 10.7 2.5 1 2.3 1.4 4.6 3 43 29.8 58.2 8.4 58.2 8.4s-4.8-4-9.3-11.4c-3.4-5.6-18.8-16.5-14.5-25.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFB893",
			d: "M325.3 98.6c1.7 2.2 5.3 4.8 3.3 6.2-2 1.4-6.9-.2-9-3.2-2.1-3-2.1-6.6-.1-8 2-1.5 4 2.7 5.8 5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFBB96",
			d: "m442.2 176-7-50.2c-.5-3-4.2-4.4-6.7-2.6-3 2.2-6.8 4.6-10.2 5.5-3.7 1-9 .8-12.5.5a4 4 0 0 0-4.3 3.2l-3 16.8c-.3 1.7-1.6 3-3.3 3.1l-29.6 2.7-1.4-.1-53.8-15.6c-.8-.3-1.5-.8-2-1.5l-17.1-24c-1.4-2-4.3-2-5.6 0-2.5 4-5.6 10.4-4 16 2.7 9.3 9 15.6 17.7 19.6a1468.7 1468.7 0 0 0 76 30.9h63c2.4 0 4.1-2 3.8-4.3Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 318.5,
			cy: 101.9,
			fill: "#FFBB96",
			rx: 35.6,
			ry: 45.1,
			transform: "rotate(-61 318.5 102)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M298.7 83c4.7-10.4-1.7-12.2-1.7-12.2s20.4-5.4 33.3 0c5.8 2.4 16.1 8.6 16.1 8.6S322.7 50.6 306.3 53c-10.5 1.5-8.6 6.2-17.5 11.9-7.8 4.9-12.5 2.6-19.8 12.1-5.3 7-16.3 18-11.2 25.4 2.1 3 4.3 1.6 6 5 2.6 5.2-1.7 10.2 5.2 13.1 3 1.3 2.3 3.4 5.6 3.6 16 1 24.4 7.8 24.4 7.8s-2.6-2.2-8.2-11.4c-4.2-7 2.6-26 7.9-37.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#D5733F",
			strokeLinecap: "round",
			strokeWidth: 1.4,
			d: "M323.1 114.1c.7 3.3-1.3 8.6 1.3 9.1 3.3.8 5.3-4.5 5.3-4.5m1.9 11.6s8-2 10-5.3c2-3.4-.3-11.5-.3-11.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeLinecap: "round",
			strokeWidth: 2.1,
			d: "M318.4 101.4s5.1-.4 6.4-3.1c1-2.4-1.2-6-1.2-6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeLinecap: "round",
			strokeWidth: 1.4,
			d: "M317.7 83.8s-3.4 3.2-5.6 7.3c-2 3.5-2.4 6.7-2.4 6.7m-7.1 9.7s-3.4 3.2-5.7 7.3c-2 3.5-2.4 6.7-2.4 6.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeLinecap: "round",
			strokeWidth: 2.1,
			d: "M304.6 123s5-.4 6.3-3c1-2.4-1.2-5.9-1.2-5.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFBB96",
			d: "M350 74.6c2.6 3.7 3.2 8.8.7 10.5-2.5 1.8-8.5-.2-11-4-2.7-3.6-2.8-8.1-.2-9.9 2.5-1.7 8-.3 10.5 3.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#993F00",
			fillOpacity: .2,
			d: "M665.6 228.8c21 4.4 44.8 26.7 53.1 35a7.7 7.7 0 0 0 7.2 2c7.4-1.7 22.7-5.7 33-9.9 11-4.4 25.9-13 31.8-16.5a7 7 0 0 0 3.2-4.4c2.5-11 9.9-50.6-9.3-67.5-16.4-14.4-36.2-14-56.9-20.7-16.2-5.3-20.9-8.4-37.2-13.2-18.2-5.3-32-5.4-50-10.9-32.2-9.7-36.9-36.6-72-40.3a260.9 260.9 0 0 0-51.6 2.8c-1.2.1-2.4 0-3.6-.4l-34.6-12a13 13 0 0 0-9.3 0c-3 1.1-7 2.8-9.6 4.7-12.5 8.9-8.6 22.4-16.6 35.4-18.2 29.7-35.9 41.7-64.4 61.7a376.3 376.3 0 0 1-27.9 17.1 15.4 15.4 0 0 0-7.8 13.4v70.8c0 8.6 7.1 15.5 15.7 15.4 17.9-.1 47.3.4 68.2 5 27.7 5.9 37.9 17.3 65.9 21.7 22.8 3.7 38.6-1 61.3 3 13.4 2.5 20 11 33.5 9.8 23.8-2.1 14.4-29 23.4-51.1 7.9-19.6-.4-41.2 18.4-50.9 12.6-6.4 22.3-2.8 36.1 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFF4E0",
			d: "M671.7 222.8c21 4.4 44.8 26.6 53 35a7.7 7.7 0 0 0 7.3 2c7.3-1.7 22.6-5.7 33-9.9 11-4.4 25.8-13 31.7-16.5a7 7 0 0 0 3.3-4.4c2.5-11 9.8-50.6-9.4-67.5-16.3-14.4-36.1-14-56.8-20.7-16.3-5.3-21-8.4-37.3-13.2-18.1-5.4-32-5.4-50-11-32.1-9.7-36.9-36.5-72-40.2a260.9 260.9 0 0 0-51.6 2.8c-1.2.1-2.4 0-3.6-.4l-34.6-12a13 13 0 0 0-9.3 0c-3 1.1-7 2.8-9.6 4.7-12.4 8.9-8.6 22.4-16.6 35.4-18.2 29.7-35.8 41.7-64.3 61.7a376.8 376.8 0 0 1-28 17.1 15.4 15.4 0 0 0-7.8 13.4v70.8c0 8.6 7.2 15.5 15.8 15.4 17.8-.2 47.2.4 68.1 4.9 27.7 6 38 17.4 65.9 21.8 22.8 3.6 38.6-1 61.3 3 13.5 2.5 20 11 33.5 9.8 23.8-2.2 14.4-29 23.4-51.2 7.9-19.5-.4-41.2 18.4-50.8 12.6-6.4 22.3-2.8 36.2 0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EBD0B3",
			d: "M404.5 221.7c-3.6 17.9 2 45.2 3.4 52 .1.5.9.7 1.2.2a31 31 0 0 0 5.1-11.6c3-19.2-3-37.4 2-51.5 5-14.1 6.3-17 13.9-25.2 5-5.7 19-14.5 27.3-19.5.8-.5.2-1.8-.7-1.5l-8.6 2.9c-.7.3-22 9.7-30.8 21-8.6 11-10.2 19.6-12.8 33.2ZM538.7 249a92 92 0 0 0 2 30.6c0 .7.8.8 1.2.3.9-1.5 2.3-4 2.7-6.4 1.8-11.5-1.9-22.5 1-31 3-8.4 3.9-10.1 8.4-15a75 75 0 0 1 13.7-10.2c.8-.5.2-1.8-.7-1.5l-2.2.8c-.7.3-13.2 5.9-18.4 12.6-5.1 6.6-6 11.7-7.7 19.9Zm-50.8-81.4c8.7 7.6 25.3 13.3 30.3 15 .6.2 1.1-.4.8-1a19 19 0 0 0-4.6-6.3c-10-8-22.5-10.5-28.9-18a36.5 36.5 0 0 1-9.8-16.4 96 96 0 0 1-2-19.5c0-1-1.4-1-1.6-.2l-.7 3.4c0 .7-1.7 16 1.8 24.7 3.4 8.5 7.8 12.2 14.7 18.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EBD0B3",
			d: "M492.6 160c6.4 9.6 21 19.4 25.4 22.2.5.4 1.1 0 1-.7a19 19 0 0 0-2.9-7.2c-7.5-10.4-19-16-23.2-25a36.4 36.4 0 0 1-5.2-18.3 92.8 92.8 0 0 1 3.1-19.3c.2-1-1.1-1.4-1.5-.6l-1.5 3c-.3.7-5.8 15-4.7 24.3 1.1 9.2 4.4 13.9 9.5 21.5Zm129.5 27.7a97.7 97.7 0 0 0 33.7-2.5c.6-.1.8-.9.3-1.2a20 20 0 0 0-7.2-3c-12.7-1.9-24.7 2.3-34-1a36.5 36.5 0 0 1-16.8-9 93 93 0 0 1-11.7-15.8c-.5-.8-1.8-.1-1.5.7l1.1 3.2a65 65 0 0 0 14.2 20.4c7.2 5.6 13 6.6 22 8.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EBD0B3",
			d: "M669.5 180.7a100.4 100.4 0 0 0-33.7 2.6c-.6.1-.7.9-.2 1.2a20 20 0 0 0 7.2 3c12.7 1.9 24.7-2.3 34 1a36.5 36.5 0 0 1 16.8 9c3.3 3 8.2 10.3 11.6 15.8.5.7 1.8.1 1.5-.7l-1-3.2h-.1c-.3-.7-6.6-14.7-14.1-20.4-7.3-5.6-13-6.6-22-8.3Zm1.1-34.7a130.9 130.9 0 0 0-25.7-19.3c-.6-.3-1.2.2-1 .8.7 1.8 2 4.6 4 6.5 9 9 19.4 18.1 26.7 21 7.3 3 16.2 4.3 17.7 11.5 1.2 6 40 .6 54-1.5.8 0 .7-1.3-.1-1.4l-5.6-.8h-.2c-2.2.3-44 6-46.6-3.1-2.5-8.8-17-6.9-23.2-13.6Z"
		})
	]
});
export default SvgBed;
